import $api from './instance';
import { Notification } from '@/types/notifications';

interface NotificationsResponse {
  notifications: Notification[];
  total: number;
}

// Define the filter interface
interface NotificationFilters {
  type?: string;
  limit?: number;
  page?: number;
  tenantId?: number;
}

export const getNotifications = async (filters: NotificationFilters): Promise<NotificationsResponse> => {
  try {
    const params = new URLSearchParams();

    if (filters.tenantId) {
      params.append('tenantId', String(filters.tenantId));
    }
    if (filters.type && filters.type !== 'all-types') {
      params.append('entityType', filters.type);
    }
    if (filters.limit) {
      params.append('limit', String(filters.limit));
    }
    if (filters.page) {
      params.append('page', String(filters.page));
    }

    const queryString = params.toString();
    const url = queryString ? `/notifications?${queryString}` : '/notifications';

    const response = await $api.get(url);

    if (response.data && Array.isArray(response.data.data)) {
      return {
        notifications: response.data.data,
        total: response.data.total,
      };
    }

    return { notifications: [], total: 0 };

  } catch (error) {
    console.error('Error fetching notifications:', error);
    throw error;
  }
};

export const markAllAsRead = async (): Promise<void> => {
  try {
    await $api.put('/notifications/read-all');
  } catch (error) {
    console.error('Error marking all notifications as read:', error);
    throw error;
  }
};
